import welcomeVideoThumb from "@/assets/images/components/onboarding/welcome_video_thumb.png";
import type { WelcomeTileProps } from "@/ui/components/onboarding/welcome/WelcomeTile";
import { FAIconName } from "@/ui/core";

// Fallback CDN URL for video resources when LaunchDarkly feature flag is not yet loaded
// This ensures videos load correctly on initial page load before feature flags are hydrated
const FallbackVideoResourcesCdnUrl =
  "https://equip-media-prod.s3-accelerate.amazonaws.com/resources/videos/";

const WelcomeText = {
  thumbnail: welcomeVideoThumb,
  videoTitle: "Welcome to Equip",
  videoUrl: "Welcome Video.mp4",
};

const WelcomeFeatures: WelcomeTileProps[] = [
  {
    icon: FAIconName.Calendars,
    title: "Join and book appointments",
  },
  {
    icon: FAIconName.Messages,
    title: "Chat with your dedicated team",
  },
  {
    icon: FAIconName.OpenBook,
    title: "Explore groups and resources",
  },
];

const ConsentText = {
  AdditionalConsentSectionDescription:
    "Please review their information and the following permissions needed to ensure seamless care while in treatment.",
  AdditionalConsentTitle: "A patient has been added",
  ConsentSectionDescription:
    "Please review the following permissions needed to ensure seamless care while in treatment.",
  ConsentSectionTitle: "One more step!",
  RecordingConsent:
    "All video recordings will be stored securely within a HIPAA-compliant, cloud-based platform.",
  RecordingConsentTitle: (name?: string) => {
    const possessive = name ? `${name}'s` : "my";
    return `I consent to Equip recording sessions related to ${possessive} treatment for internal quality assurance and training purposes.`;
  },
};

enum MedicalReviewState {
  Approved = "approved",
  NotApproved = "notApproved",
  Pending = "pending",
}

enum OnboardingStepName {
  CareTeam = "careTeam",
  ClinicalPicture = "clinicalPicture",
  Initial = "initial",
  Profile = "profile",
  Treatment = "treatment",
  YourWhy = "yourWhy",
}

const OrderedOnboardingSteps: OnboardingStepName[] = [
  OnboardingStepName.Profile,
  OnboardingStepName.ClinicalPicture,
  OnboardingStepName.Treatment,
  OnboardingStepName.CareTeam,
  OnboardingStepName.YourWhy,
];

const TotalOnboardingSteps = OrderedOnboardingSteps.length + 1;

export {
  ConsentText,
  FallbackVideoResourcesCdnUrl,
  MedicalReviewState,
  OnboardingStepName,
  OrderedOnboardingSteps,
  TotalOnboardingSteps,
  WelcomeFeatures,
  WelcomeText,
};
